module.exports = __webpack_public_path__ + "static/media/INSTA.510c3239.jpg";